export const getRecaptchaToken = state => state.googleRecaptcha.token;
export const getRecaptchaSiteKey = state => state.googleRecaptcha.sitekey;